// src/pages/help/topics/faqGenerale.js
// Guide « FAQ générale ». Contenu validé — toute modification se fait ici.
export const fr = {
  title: "FAQ générale",
  tagline: "Réponses aux questions les plus courantes",
  readMin: 7,
  intro:
    "FullMetrix est la plateforme premium de FullMargin dédiée aux traders. Elle regroupe les outils pour connecter des comptes MetaTrader 5, synchroniser les trades, analyser les performances, tenir un journal automatique, gérer des positions, copier des trades, créer des challenges, concevoir des stratégies, backtester et consulter des données d'analyse fondamentale.",
  brief: [
    "Comprendre ce qu'est FullMetrix et à qui il s'adresse",
    "Savoir par où commencer : l'Agent IA sur MetaTrader 5",
    "Trouver la documentation dédiée de chaque outil",
  ],
  steps: [
    {
      title: "Installer l'Agent IA sur MetaTrader 5",
      text: "C'est la première étape : l'Agent relie le compte de trading à FullMetrix.",
    },
    {
      title: "Laisser les données se synchroniser",
      text: "Une fois l'Agent connecté, les trades alimentent le journal automatique et les statistiques.",
    },
    {
      title: "Utiliser les outils",
      text: "Exécution, Copy Trading, Challenges, Strategy Hub, Backtest et Analyse fondamentale deviennent alors exploitables.",
    },
  ],
  tips: [
    "Aucun gain n'est garanti : FullMetrix aide à décider, il ne remplace ni la stratégie, ni la gestion du risque, ni la discipline.",
    "Un compte MT5 à connecter = un Agent configuré.",
    "Ne partagez jamais vos mots de passe ni vos informations sensibles.",
  ],
  faq: [
    {
      q: "Qu'est-ce que FullMetrix ?",
      a:
        "FullMetrix est la plateforme premium de FullMargin dédiée aux traders.\n\n" +
        "Elle regroupe plusieurs outils pour :\n" +
        "• connecter des comptes MetaTrader 5\n" +
        "• synchroniser automatiquement les trades\n" +
        "• analyser les performances\n" +
        "• utiliser un journal de trading automatique\n" +
        "• gérer des positions\n" +
        "• copier des trades sur plusieurs comptes\n" +
        "• créer des challenges\n" +
        "• concevoir des stratégies\n" +
        "• effectuer des backtests\n" +
        "• consulter des données d'analyse fondamentale",
    },
    {
      q: "À qui s'adresse FullMetrix ?",
      a:
        "FullMetrix s'adresse principalement :\n" +
        "• aux traders débutants qui veulent mieux s'organiser\n" +
        "• aux traders expérimentés qui souhaitent analyser leurs performances\n" +
        "• aux utilisateurs de plusieurs comptes MT5\n" +
        "• aux traders qui veulent améliorer leur discipline et leur gestion du risque\n" +
        "• aux personnes qui souhaitent centraliser leurs outils sur une seule plateforme",
    },
    {
      q: "FullMetrix permet-il de devenir automatiquement rentable ?",
      a:
        "Non.\n\n" +
        "FullMetrix fournit des outils d'analyse, de suivi et d'aide à la décision.\n\n" +
        "La plateforme ne remplace pas :\n" +
        "• une stratégie de trading\n" +
        "• une bonne gestion du risque\n" +
        "• l'expérience\n" +
        "• la discipline\n" +
        "• la responsabilité du trader\n\n" +
        "Aucun gain n'est garanti.",
    },
    {
      q: "Comment commencer sur FullMetrix ?",
      a:
        "La première étape consiste à installer l'Agent IA sur MetaTrader 5.\n\n" +
        "L'Agent permet de relier le compte de trading à FullMetrix afin de :\n" +
        "• synchroniser les trades\n" +
        "• alimenter le journal automatique\n" +
        "• afficher les statistiques\n" +
        "• utiliser les fonctions d'exécution et de gestion",
    },
    {
      q: "Qu'est-ce que l'Agent IA MT5 ?",
      a:
        "L'Agent IA est un programme installé sur MetaTrader 5.\n\n" +
        "Il permet de connecter le compte de trading à FullMetrix et de transmettre les données nécessaires au fonctionnement des différents outils.\n\n" +
        "Chaque compte MT5 à connecter doit disposer de son propre Agent configuré.",
    },
    {
      q: "Peut-on connecter plusieurs comptes MT5 ?",
      a:
        "Oui.\n\n" +
        "FullMetrix permet de connecter, gérer et analyser plusieurs comptes MT5.\n\n" +
        "L'utilisateur peut consulter :\n" +
        "• les performances d'un compte précis\n" +
        "• les résultats globaux de plusieurs comptes\n" +
        "• l'état de connexion de chaque Agent\n" +
        "• les trades associés à chaque compte",
    },
    {
      q: "Qu'est-ce que le journal automatique ?",
      a:
        "Le journal automatique récupère les données des comptes MT5 connectés.\n\n" +
        "Il permet de retrouver :\n" +
        "• les positions ouvertes et clôturées\n" +
        "• les gains et les pertes\n" +
        "• le taux de réussite\n" +
        "• les performances par période\n" +
        "• les résultats par actif\n" +
        "• les performances en BUY et en SELL\n" +
        "• le risque et le drawdown\n" +
        "• les habitudes et erreurs récurrentes\n\n" +
        "Des filtres permettent d'affiner les analyses.",
    },
    {
      q: "Peut-on prendre des positions depuis FullMetrix ?",
      a:
        "Oui, depuis la partie Exécution, lorsque le compte MT5 est correctement connecté.\n\n" +
        "L'utilisateur peut notamment :\n" +
        "• ouvrir une position\n" +
        "• définir le volume\n" +
        "• placer un Stop Loss\n" +
        "• placer un Take Profit\n" +
        "• créer des ordres en attente\n" +
        "• modifier ou fermer plusieurs positions",
    },
    {
      q: "Comment fonctionne le Copy Trading ?",
      a:
        "Le Copy Trading permet de connecter plusieurs comptes MT5.\n\n" +
        "Un compte principal envoie les positions aux autres comptes connectés grâce aux Agents copieurs.\n\n" +
        "L'utilisateur peut configurer :\n" +
        "• les comptes concernés\n" +
        "• le volume\n" +
        "• le niveau de risque\n" +
        "• l'activation ou l'arrêt de la copie",
    },
    {
      q: "À quoi servent les Challenges ?",
      a:
        "La partie Challenges permet de créer des objectifs personnels de trading.\n\n" +
        "L'utilisateur peut définir :\n" +
        "• un objectif de profit\n" +
        "• une limite de perte\n" +
        "• une durée\n" +
        "• un capital de départ\n" +
        "• des règles à respecter\n\n" +
        "FullMetrix suit ensuite automatiquement la progression du challenge.",
    },
    {
      q: "À quoi sert le Strategy Hub ?",
      a:
        "Le Strategy Hub permet de créer, organiser et suivre ses stratégies de trading.\n\n" +
        "L'utilisateur peut y enregistrer :\n" +
        "• ses conditions d'entrée\n" +
        "• ses conditions de sortie\n" +
        "• ses règles d'invalidation\n" +
        "• sa gestion du risque\n" +
        "• les marchés concernés\n" +
        "• ses observations\n\n" +
        "L'intelligence artificielle peut également proposer des pistes d'amélioration.",
    },
    {
      q: "Comment fonctionne le Backtest ?",
      a:
        "FullMetrix propose un outil de backtest compatible avec MetaTrader 5.\n\n" +
        "Il permet de tester une stratégie sur l'historique de plusieurs marchés :\n" +
        "• Forex\n" +
        "• indices\n" +
        "• indices synthétiques\n" +
        "• matières premières\n" +
        "• autres actifs disponibles sur MT5\n\n" +
        "L'utilisateur peut simuler des prises de position et analyser les résultats obtenus.",
    },
    {
      q: "À quoi sert l'analyse fondamentale ?",
      a:
        "La partie Analyse fondamentale regroupe des données macroéconomiques utiles à la préparation du trading.\n\n" +
        "Elle permet notamment de :\n" +
        "• suivre les événements économiques importants\n" +
        "• comprendre le contexte du marché\n" +
        "• anticiper certaines périodes de volatilité\n" +
        "• préparer ses scénarios de trading",
    },
    {
      q: "Mes données sont-elles modifiées par FullMetrix ?",
      a:
        "FullMetrix utilise les données transmises par les comptes connectés pour faire fonctionner ses outils.\n\n" +
        "L'utilisateur reste responsable :\n" +
        "• de ses identifiants\n" +
        "• de ses comptes MT5\n" +
        "• des autorisations accordées\n" +
        "• des décisions prises depuis la plateforme\n\n" +
        "Les mots de passe et informations sensibles ne doivent jamais être partagés.",
    },
    {
      q: "Comment contacter l'assistance ?",
      a:
        "L'équipe FullMargin peut être contactée depuis le Centre d'aide :\n" +
        "• par WhatsApp\n" +
        "• par e-mail\n" +
        "• via le bouton Contacter l'assistance\n\n" +
        "Pour obtenir une réponse rapide, il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• le nom de l'outil concerné\n" +
        "• une description claire du problème\n" +
        "• une capture d'écran\n" +
        "• le message d'erreur, s'il existe",
    },
    {
      q: "Où trouver les guides de chaque fonctionnalité ?",
      a:
        "Chaque outil possède une documentation dédiée dans le Centre d'aide :\n" +
        "• Agent IA MT5\n" +
        "• Chat IA\n" +
        "• Journal automatique\n" +
        "• Exécution\n" +
        "• Copy Trading\n" +
        "• Challenges\n" +
        "• Strategy Hub\n" +
        "• Analyse fondamentale\n" +
        "• Graphiques et Backtest\n" +
        "• Autres fonctionnalités",
    },
  ],
  related: ["agent-ia-mt5", "journal-auto", "autres"],
};

export const en = {
  title: "General FAQ",
  tagline: "Answers to the most common questions",
  readMin: 7,
  intro:
    "FullMetrix is the premium FullMargin platform for traders. It brings together the tools to connect MetaTrader 5 accounts, sync trades, analyse performance, keep an automatic journal, manage positions, copy trades, create challenges, design strategies, backtest and consult fundamental analysis data.",
  brief: [
    "Understand what FullMetrix is and who it is for",
    "Know where to start: the AI Agent on MetaTrader 5",
    "Find the dedicated documentation for each tool",
  ],
  steps: [
    { title: "Install the AI Agent on MetaTrader 5", text: "This is the first step: the Agent links the trading account to FullMetrix." },
    {
      title: "Let the data sync",
      text: "Once the Agent is connected, trades feed the automatic journal and the statistics.",
    },
    {
      title: "Use the tools",
      text: "Execution, Copy Trading, Challenges, Strategy Hub, Backtest and Fundamental analysis then become usable.",
    },
  ],
  tips: [
    "No gain is guaranteed: FullMetrix helps you decide — it replaces neither strategy, risk management nor discipline.",
    "One MT5 account to connect = one configured Agent.",
    "Never share your passwords or sensitive information.",
  ],
  faq: [
    {
      q: "What is FullMetrix?",
      a:
        "FullMetrix is the premium FullMargin platform for traders.\n\n" +
        "It brings together several tools to:\n" +
        "• connect MetaTrader 5 accounts\n" +
        "• sync trades automatically\n" +
        "• analyse performance\n" +
        "• use an automatic trading journal\n" +
        "• manage positions\n" +
        "• copy trades across several accounts\n" +
        "• create challenges\n" +
        "• design strategies\n" +
        "• run backtests\n" +
        "• consult fundamental analysis data",
    },
    {
      q: "Who is FullMetrix for?",
      a:
        "FullMetrix is mainly for:\n" +
        "• beginner traders who want to get organised\n" +
        "• experienced traders who want to analyse their performance\n" +
        "• users running several MT5 accounts\n" +
        "• traders who want to improve discipline and risk management\n" +
        "• anyone who wants to centralise their tools on a single platform",
    },
    {
      q: "Does FullMetrix make me automatically profitable?",
      a:
        "No.\n\n" +
        "FullMetrix provides analysis, tracking and decision-support tools.\n\n" +
        "The platform does not replace:\n" +
        "• a trading strategy\n" +
        "• sound risk management\n" +
        "• experience\n" +
        "• discipline\n" +
        "• the trader's responsibility\n\n" +
        "No gain is guaranteed.",
    },
    {
      q: "How do I get started on FullMetrix?",
      a:
        "The first step is to install the AI Agent on MetaTrader 5.\n\n" +
        "The Agent links the trading account to FullMetrix in order to:\n" +
        "• sync trades\n" +
        "• feed the automatic journal\n" +
        "• display statistics\n" +
        "• enable execution and management features",
    },
    {
      q: "What is the MT5 AI Agent?",
      a:
        "The AI Agent is a program installed on MetaTrader 5.\n\n" +
        "It connects the trading account to FullMetrix and transmits the data the various tools need.\n\n" +
        "Each MT5 account to connect must have its own configured Agent.",
    },
    {
      q: "Can I connect several MT5 accounts?",
      a:
        "Yes.\n\n" +
        "FullMetrix lets you connect, manage and analyse several MT5 accounts.\n\n" +
        "You can review:\n" +
        "• the performance of a specific account\n" +
        "• the overall results across several accounts\n" +
        "• the connection state of each Agent\n" +
        "• the trades attached to each account",
    },
    {
      q: "What is the automatic journal?",
      a:
        "The automatic journal pulls data from the connected MT5 accounts.\n\n" +
        "It shows:\n" +
        "• open and closed positions\n" +
        "• profits and losses\n" +
        "• win rate\n" +
        "• performance per period\n" +
        "• results per asset\n" +
        "• BUY and SELL performance\n" +
        "• risk and drawdown\n" +
        "• recurring habits and mistakes\n\n" +
        "Filters let you refine the analysis.",
    },
    {
      q: "Can I take positions from FullMetrix?",
      a:
        "Yes, from the Execution section, once the MT5 account is properly connected.\n\n" +
        "You can:\n" +
        "• open a position\n" +
        "• set the volume\n" +
        "• place a Stop Loss\n" +
        "• place a Take Profit\n" +
        "• create pending orders\n" +
        "• modify or close several positions",
    },
    {
      q: "How does Copy Trading work?",
      a:
        "Copy Trading connects several MT5 accounts.\n\n" +
        "A main account sends its positions to the other connected accounts through the copier Agents.\n\n" +
        "You can configure:\n" +
        "• the accounts involved\n" +
        "• the volume\n" +
        "• the risk level\n" +
        "• starting or stopping the copy",
    },
    {
      q: "What are Challenges for?",
      a:
        "The Challenges section lets you create personal trading targets.\n\n" +
        "You can define:\n" +
        "• a profit target\n" +
        "• a loss limit\n" +
        "• a duration\n" +
        "• a starting balance\n" +
        "• rules to respect\n\n" +
        "FullMetrix then tracks the challenge progress automatically.",
    },
    {
      q: "What is the Strategy Hub for?",
      a:
        "The Strategy Hub lets you create, organise and follow your trading strategies.\n\n" +
        "You can record:\n" +
        "• entry conditions\n" +
        "• exit conditions\n" +
        "• invalidation rules\n" +
        "• risk management\n" +
        "• the markets involved\n" +
        "• your observations\n\n" +
        "The AI can also suggest improvement paths.",
    },
    {
      q: "How does the Backtest work?",
      a:
        "FullMetrix offers a backtest tool compatible with MetaTrader 5.\n\n" +
        "It lets you test a strategy on the history of several markets:\n" +
        "• Forex\n" +
        "• indices\n" +
        "• synthetic indices\n" +
        "• commodities\n" +
        "• other assets available on MT5\n\n" +
        "You can simulate positions and analyse the results.",
    },
    {
      q: "What is fundamental analysis for?",
      a:
        "The Fundamental analysis section gathers macroeconomic data useful to prepare your trading.\n\n" +
        "It lets you:\n" +
        "• follow major economic events\n" +
        "• understand the market context\n" +
        "• anticipate volatility windows\n" +
        "• prepare your trading scenarios",
    },
    {
      q: "Is my data modified by FullMetrix?",
      a:
        "FullMetrix uses the data sent by the connected accounts to run its tools.\n\n" +
        "You remain responsible for:\n" +
        "• your credentials\n" +
        "• your MT5 accounts\n" +
        "• the permissions granted\n" +
        "• the decisions taken from the platform\n\n" +
        "Passwords and sensitive information must never be shared.",
    },
    {
      q: "How do I contact support?",
      a:
        "The FullMargin team can be reached from the Help center:\n" +
        "• on WhatsApp\n" +
        "• by email\n" +
        "• via the Contact support button\n\n" +
        "For a fast answer, send:\n" +
        "• the email address of your FullMargin account\n" +
        "• the name of the tool involved\n" +
        "• a clear description of the problem\n" +
        "• a screenshot\n" +
        "• the error message, if any",
    },
    {
      q: "Where do I find the guides for each feature?",
      a:
        "Every tool has its own documentation in the Help center:\n" +
        "• MT5 AI Agent\n" +
        "• AI Chat\n" +
        "• Automatic journal\n" +
        "• Execution\n" +
        "• Copy Trading\n" +
        "• Challenges\n" +
        "• Strategy Hub\n" +
        "• Fundamental analysis\n" +
        "• Charting and Backtest\n" +
        "• Other features",
    },
  ],
  related: ["agent-ia-mt5", "journal-auto", "autres"],
};
